// ** React Imports
// ** React Toastify
import { lazy, Suspense } from "react";
import ReactDOM from "react-dom";
// ** Redux Imports
import { Provider } from "react-redux";
// ** Intl & ThemeColors Context
import { ConfigProvider } from "antd/lib";

import AuthProvider from "@configs/provider/auth/auth-provider";
import theme from "@configs/theme";

// ** Ripple Button
// import "./@core/components/ripple-button";
// ** PrismJS
import "prismjs";
import "prismjs/components/prism-jsx.min";
import "./assets/Fonts/Red_Hat_Display/static/RedHatDisplay-Bold.ttf";
import "./assets/Fonts/Red_Hat_Display/static/RedHatDisplay-Regular.ttf";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";
import { store } from "./redux/store";
import { ThemeContext } from "./utility/context/ThemeColors";
import { FirebaseProvider } from "./firebase";
// ** Service Worker
import * as serviceWorker from "./serviceWorker";

import "@styles/react/libs/toastify/toastify.scss";
import "prismjs/themes/prism-tomorrow.css";
// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
// Tailwind
import "./_assets/css/output.css";
import "./assets/scss/style.scss";
import "./index.css";

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));
// firebase.initializeApp({
//   apiKey: "AIzaSyAcom0N7seGFILTFhFO1Jq_HiILPt1IBbA",
//   authDomain: "popin-bdcc2.firebaseapp.com",
//   projectId: "popin-bdcc2",
//   storageBucket: "popin-bdcc2.appspot.com",
//   messagingSenderId: "90899402436",
//   appId: "1:90899402436:web:e4497e442e44fa27ad0391",
//   measurementId: "G-P8ELNV826T",
// });

ReactDOM.render(
  <Provider store={store}>
    <FirebaseProvider>
      <Suspense fallback={<Spinner />}>
        <ThemeContext>
          <ConfigProvider theme={theme}>
            <AuthProvider>
              <LazyApp />
            </AuthProvider>
          </ConfigProvider>
        </ThemeContext>
      </Suspense>
    </FirebaseProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
